export default "__VITE_ASSET__Ckhg5s3A__"